module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Code/Lock-overturning-cb895e27b8396ffd5991cab64bd31f42.svg";